module.exports = __webpack_public_path__ + "img/plants-darkblue.976ad363.png";